define('common/views/modal_layout',['require','exports','module','./modal_view','base/region','base/layout'],function(require, exports, module) {
  "use strict";

  var ModalView = require("./modal_view"),
      Region = require("base/region"),
      Layout = require("base/layout");

  var layProto = Layout.prototype;

  // this class kind of inherits from both ModalView and Layout

  module.exports = ModalView.extend({
    constructor: function(options) {
      options = options || {};
      var regions = options.regions || this.regions || {};
      this.regions = {};
      this._regions = [];
      _.each(regions, this.addRegion, this);
      var res = module.exports.__super__.constructor.apply(this, arguments);
      return res;
    },
    delegateEvents: function() {
      module.exports.__super__.delegateEvents.apply(this, arguments);
      _.each(this._regions, function(regionData) {
        regionData.region.delegateEvents();
      });
    },
    remove: function() {
      module.exports.__super__.remove.apply(this, arguments);
      if (this.regions) { _.invoke(this.regions, "close"); }
    }
  });

  _.extend(module.exports.prototype,
           _.pick(Layout.prototype, "regionType", "addRegion", "addRegions",
                  "reattachRegions", "render", "setElement",
                  "detachRegions"));

});

